import { createContext, useContext, useSyncExternalStore, type ReactNode } from "react"

import type { AuthController, AuthState } from "./session"

const AuthContext = createContext<AuthController | null>(null)

export function AuthProvider({ controller, children }: { controller: AuthController; children: ReactNode }) {
  return <AuthContext.Provider value={controller}>{children}</AuthContext.Provider>
}

export function useAuthController(): AuthController {
  const controller = useContext(AuthContext)
  if (!controller) throw new Error("AuthProvider missing")
  return controller
}

export function useAuthState(): AuthState {
  const controller = useAuthController()
  return useSyncExternalStore(controller.subscribe, controller.getState)
}
